import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Icon, List, Grid } from 'semantic-ui-react';
import i18next from 'i18next';
import WebsiteEditor from './WebsiteEditor';
import WebsiteAccessKeys from './WebsiteAccessKeys';
import SideEditor from '../../general/SideEditor';
import { fetchWebsite, setEditedEntity, fetchBrands } from '../../../actions';
import { hasSuperPermission } from '../../../helpers/permissions';

const Website = (props) => {
    const dispatch = useDispatch();
    const chainId = useSelector(state => state.businessApp.chainId);
    const chainBranches = useSelector(state => state.businessApp.restaurants.filter(r => r.ownerId == chainId));
    const isWebsiteOnEdit = useSelector(state => state.editor.type === 'website');
    const website = useSelector(state => state.businessApp.website);
    const [selectedBranch, selectBranch] = useState(null);
    const websiteHref = useSelector(state => `${state.meta.webappUrl || 'https://orders.paidit.io/'}?chainId=${chainId}`);

    useEffect(() => {
        if (chainId) {
            dispatch(fetchWebsite(chainId));
            dispatch(fetchBrands(null, chainId));
        }
    }, [chainId]);

    if (!website) {
        if (!hasSuperPermission('operation')) return null;

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('website.title')}
                    visible={isWebsiteOnEdit}
                    handleClose={() => dispatch(setEditedEntity(null))}
                >
                    <WebsiteEditor />
                </SideEditor>
                <Button onClick={() => dispatch(setEditedEntity('website', { chainId }))}>
                    {'Setup website'}
                </Button>
            </div>
        );
    }

    const renderBranchList = () => {
        return chainBranches.map(branch => (
            <List.Item key={branch.id} active={selectedBranch && selectedBranch.id === branch.id} onClick={() => selectBranch(branch)}>
                <List.Icon name='circle' size='large' verticalAlign='middle' color={!website.branchesIds || website.branchesIds.includes(branch.id) ? 'green' : 'red'} />
                <List.Content>
                    <List.Header>{branch.name}</List.Header>
                </List.Content>
            </List.Item>
        ));
    };

    return (
        <Grid stackable columns={2}>
            <Grid.Column width={5}>
                <div style={{ padding: 10, display: 'flex' }}>
                    <SideEditor
                        title={i18next.t('website.title')}
                        visible={isWebsiteOnEdit}
                        handleClose={() => dispatch(setEditedEntity(null))}
                    >
                        <WebsiteEditor />
                    </SideEditor>
                    <div>
                        <Card>
                            <Card.Content>
                                <Button floated="right" circular size='mini' icon='setting' onClick={() => dispatch(setEditedEntity('website', website))} />
                                <Card.Header>{i18next.t('website.title')}</Card.Header>
                                <Card.Meta>
                                    <span className='date'>{i18next.t(website.isDisabled ? 'inactive' : 'active')}</span>
                                </Card.Meta>
                            </Card.Content>
                            <Card.Content extra>
                                <a target='_blank' rel="noopener noreferrer" href={websiteHref}>
                                    <Icon name='external' />
                                    {websiteHref}
                                </a>
                            </Card.Content>
                        </Card>
                        <Card>
                            <List selection divided verticalAlign='middle'>
                                {renderBranchList()}
                            </List>
                        </Card>
                    </div>
                </div>
            </Grid.Column>
            <Grid.Column width={11}>
                {selectedBranch ? <div style={{ flex: 1 }}><WebsiteAccessKeys branchId={selectedBranch.id} /></div> : null}
            </Grid.Column>
        </Grid>
    );
};

export default Website;